import { Tag } from 'antd';
import { FormikProps } from 'formik';
import { get } from 'lodash';
import { FormCardContainer } from 'views/declarations/common/cards/NewFormCard';
import { ErrorLabel, InputLabel } from 'components/ui/composed/declarations/formInput/DeclarationInput.styles';

type Props = {
    formik: FormikProps<any>;
    path: string;
};

/**
 * The ENS filings the arrival covers, held as plain MRNs.
 *
 * An arrival is raised from one manifest and covers the ENS filings of that manifest, so the MRNs
 * are gathered at creation rather than typed: they are shown here, not edited. Changing them by
 * hand would put the arrival out of step with the manifest it belongs to.
 *
 * An arrival with no MRNs cannot be submitted - it is the only link to the entry summary
 * declarations - and cannot be repaired from this form either, which is why the creation wizard
 * refuses a manifest that has no ENS filings instead of leaving a draft that goes nowhere.
 */
const RelatedMrnsField = ({ formik, path }: Props) => {
    const value: string[] = get(formik.values, path) ?? [];
    const meta = formik.getFieldMeta(path);
    const error = typeof meta.error === 'string' ? meta.error : undefined;

    return (
        <FormCardContainer oneColumn>
            <div>
                <InputLabel>Related ENS MRNs:</InputLabel>

                {value.length ? (
                    <div data-testid="arrival-notification-related-mrns">
                        {value.map((mrn) => (
                            <Tag key={mrn} style={{ marginBottom: 4 }}>
                                {mrn}
                            </Tag>
                        ))}
                    </div>
                ) : null}

                {error && <ErrorLabel>{error}</ErrorLabel>}
            </div>
        </FormCardContainer>
    );
};

export default RelatedMrnsField;
